import {Component, OnInit} from '@angular/core';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-diversity-reports',
  templateUrl: './diversity-reports.component.html',
  styleUrls: ['./diversity-reports.component.css']
})
export class DiversityReportsComponent implements OnInit {
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  countryWiseReportData;
  continentWiseReportData;
  programmeWiseReportData;
  balanceOfTradeReportData = [];
  filter_id;
  title;
  token;
  students: Student[];
  outgoingTerm;
  academicYearId = '0';
  academicYear;
  downloadExcel;
  outgoingTermId = '0';
  selectUndefinedOptionValue = '0';
  errorMessage;
  message;
  tab: any;

  constructor(private route: ActivatedRoute,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService) { }

  getAllAcademicYears() {
    this.dmService.getAll(Constants.ACADEMIC_YEAR)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.academicYear = response.data;
                if (this.academicYear.length > 0) {
                  this.academicYearId = this.academicYear[0].academic_year_id;
                }
                if (this.filter_id === 1) {
                  this.getDiversityReportData();
                } else if (this.filter_id === 2) {
                  this.getBalanceOfTradeReportData();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getDiversityReportData(): void {
    this.dmService.getOne(Constants.DIVERSITY_REPORT, this.academicYearId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.countryWiseReportData = response.data.country_wise_report;
                this.continentWiseReportData = response.data.continent_wise_report;
                this.programmeWiseReportData = response.data.programme_wise_report;
                if (this.countryWiseReportData.length === 0) {
                  this.errorMessage = 'There is no data available ' + this.message;
                }
                if (this.continentWiseReportData.length === 0) {
                  this.errorMessage = 'There is no data available ' + this.message;
                }
                if (this.programmeWiseReportData.length === 0) {
                  this.errorMessage = 'There is no data available ' + this.message;
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getBalanceOfTradeReportData(): void {
    this.dmService.getOne(Constants.BALANCE_OF_TRADE_REPORT, this.academicYearId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.balanceOfTradeReportData = response.data;
                if (this.balanceOfTradeReportData.length === 0) {
                  this.errorMessage = 'There is no data available ' + this.message;
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  yearChange() {
    if (this.filter_id === 1) {
      this.getDiversityReportData();
    } else if (this.filter_id === 2) {
      this.getBalanceOfTradeReportData();
    }
  }

  ngOnInit() {
    this.tab = 1;
    this.getAllAcademicYears();
    this.token = '?token=' + this.authenticationService.getToken();
    this.route
        .params
        .subscribe(params => {
          this.filter_id = parseInt(params['id'], 10);
        });
    if (this.filter_id === 1) {
      this.title = 'Diversity Report';
      this.downloadExcel = AppSettings.DOWNLOAD_DIVERSITY_REPORT;
      this.message = 'for Diversity Report.';
    } else if (this.filter_id === 2) {
      this.title = 'Balance Of Trade Report';
      this.downloadExcel = AppSettings.DOWNLOAD_BALANCE_OF_TRADE_REPORT;
      this.message = 'for Balance Of Trade Report.';
    } else if (this.filter_id === 3) {
      this.title = 'Feedback Report';
      this.downloadExcel = AppSettings.DOWNLOAD_FEEDBACK_REPORT;
      this.errorMessage = 'Click to download feedback report.';
    }
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}

